import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(879);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 879);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-[#eab308] text-black py-0.5 text-center font-bold text-[10px] shadow-sm uppercase tracking-widest" data-id="element-3">
      🔥 OFERTA DISPONIBLE POR TIEMPO LIMITADO 🔥
    </div>;
}